export default [
  {
    path: 'profile',
    name: 'managerProfile',
    component: () => import(/* webpackChunkName: "manager" */ '../views/manager/profile/IndexView.vue'),
    meta: {
      nameCN: '个人资料',
      icon: 'profile',
      showInNav: true,
    }
  },
  {
    path: 'publish',
    name: 'managerPublish',
    component: () => import(/* webpackChunkName: "manager" */ '../views/manager/publish/IndexView.vue'),
    meta: {
      nameCN: '我的发布',
      icon: 'supply',
      showInNav: true,
    }
  },
  // {
  //   path: 'demand',
  //   name: 'managerDemand',
  //   component: () => import(/* webpackChunkName: "manager" */ '../views/manager/demand/IndexView.vue'),
  //   meta: {
  //     nameCN: '我的需求',
  //     icon: 'demand',
  //     showInNav: true,
  //   }
  // },
  {
    path: 'collection',
    name: 'managerCollection',
    component: () => import(/* webpackChunkName: "manager" */ '../views/manager/collection/IndexView.vue'),
    meta: {
      nameCN: '我的收藏',
      icon: 'collection',
      showInNav: true,
    }
  },
  // {
  //   path: 'message',
  //   name: 'managerMessage',
  //   component: () => import(/* webpackChunkName: "manager" */ '../views/manager/message/IndexView.vue'),
  //   meta: {
  //     nameCN: '我的消息',
  //     icon: 'message',
  //     showInNav: true,
  //   }
  // },
];
